import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { MODULES } from '../../global-modules';
import { DirectivesModule } from '../../directives/directives.module';
@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    ...MODULES
  ],
  exports: [FooterComponent],

  declarations: [FooterComponent]
})
export class FooterModule {
  
 }
